import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const LYIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="LY" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#55BA07"
        fillRule="evenodd"
        d="M0 8.8h16V12H0V8.8Z"
        clipRule="evenodd"
      />
      <Path
        fill="#1D1D1D"
        fillRule="evenodd"
        d="M0 3h16v6H0V3Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E11C1B"
        fillRule="evenodd"
        d="M0 0h16v3.2H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#fff"
        d="M7.739 3.97c.645 0 1.486.11 1.74 1.108-.303-.367-.882-.631-1.589-.547-.707.085-1.11.86-1.11 1.625-.01.723.223 1.191 1.119 1.376.896.186 1.15-.325 1.524-.594-.04.329-.258 1.295-1.656 1.295C6.65 8.21 5.77 7.299 5.77 6.089c0-1.389.997-2.128 1.969-2.119Zm2.934 1.53.61-.128-.437.588.493.576-.73-.15-.501.535.102-.777-.74-.29.661-.208.113-.632.43.486Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
